export default __webpack_public_path__ + "static/media/reunion-house.f807176e.jpg";